import dayjs from 'dayjs';

import { UserGradeHistoriesResponseType } from '../types';
import { IUserGradeHistoryRespository } from '../repositories/UserGradeHistoryRespository';
import { DATE_FORMAT } from '../../../../../../constants/service/common/utilConstants';

export interface IGetUserGradeHistoriesUsecase {
  invoke(userId: number, currentDate: string): Promise<UserGradeHistoriesResponseType>;
}

export class GetUserGradeHistoriesUsecaseImpl implements IGetUserGradeHistoriesUsecase {
  constructor(private repository: IUserGradeHistoryRespository) {}

  async invoke(userId: number, currentDate: string): Promise<UserGradeHistoriesResponseType> {
    //가장 최근 13개월의 히스토리 내역 조회
    const userGradeHistoriesInfo = await this.repository.getUserGradeHistories(userId, {
      page: 1,
      pageSize: 13,
      sort: '-createDate',
    });

    //현재 달을 제외한 12개월의 히스토리만 필터링
    const currentMonthFilteredHistories = userGradeHistoriesInfo?.userGradeHistories.filter((history) => {
      const historyCreateDate = dayjs(history.createDate).format(DATE_FORMAT.YM_DASH_FORMAT);
      return historyCreateDate !== currentDate;
    });

    return {
      totalCount: currentMonthFilteredHistories ? currentMonthFilteredHistories.length : 0,
      userGradeHistories: currentMonthFilteredHistories,
    };
  }
}
